import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    alias: ['/index.html'],
    name: 'Home',
    component: () => import('../views/Home.vue')
  },
  {
    path: '/course-system-2',
    name: 'coursesystem2',
    component: () => import('../views/courseSystem2')
  },
  {
    path: '/course-system',
    name: 'coursesystem',
    component: () => import('../views/courseSystem')
  },
  {
    path: '/mca',
    alias: ['/mca.html'],
    name: 'mca',
    component: () => import('../views/mca')
  },
  {
    path: '/arithmetic',
    alias: ['/arithmetic.html'],
    name: 'arithmetic',
    meta: {
      title: '数据结构与算法'
    },
    component: () => import('../views/arithmetic')
  }
  // {
  //   path: '/goodJob',
  //   alias: ['/goodJob.html'],
  //   name: 'goodJob',
  //   component: () => import('../views/goodJob/index')
  // }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})


router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})

export default router
